import React, { useContext, useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import {
    useReactTable,
    getCoreRowModel,
    flexRender,
} from '@tanstack/react-table';
import { FilterContext } from '../../context/Filter';
import { fetchsubcriptionsaledetail } from '../../pages/FleetEdge/Fleetedgekpi'

const Moresubstable = () => {

    const { arn: parArn, childArn } = useContext(FilterContext);

    const { open } = useContext(FilterContext)
    const { data, isLoading, isError } = useQuery({
        queryKey: ['subcriptionsaledetail', parArn, childArn],
        queryFn: () => fetchsubcriptionsaledetail(parArn, childArn),
        enabled: !!(parArn || childArn),
    });

    // Flatten and extract only _source fields
    const actualData = useMemo(() => {
        const rawList = Array.isArray(data?.result) ? data.result : [];
        return rawList.map(item => item._source);
    }, [data]);

    // Define only the columns you need
    const columns = useMemo(
        () => [
            { accessorKey: 'vehicle_id', header: 'Vehicle ID' },
            { accessorKey: 'lob', header: 'LOB' },
            { accessorKey: 'expiry_date_time_max', header: 'Expiry Date' },
            { accessorKey: 'created_at_date', header: 'Created Date' },
            { accessorKey: 'ppl', header: 'PPL' },
            { accessorKey: 'pl', header: 'PL' },
            { accessorKey: 'new_package_sold', header: 'Subscription Type' },
            { accessorKey: 'product_code', header: 'Product Code' },
            { accessorKey: 'amount', header: 'Amount' },
        ],
        []
    );

    const table = useReactTable({
        data: actualData,
        columns,
        getCoreRowModel: getCoreRowModel(),
    });

    if (isLoading) return <div>Loading...</div>;
    if (isError) return <div>Error loading data</div>;
    if (actualData.length === 0) return <div>No data available</div>;

    return (
        <div className="p-4">
            <div className="overflow-x-auto">
                <div className={` w-96 md:${open ? 'w-[950px]' : 'w-full'} max-h-[300px] overflow-y-auto   rounded`}>
                    <table className="min-w-full">
                        <thead className="sticky top-0 bg-gray-300 z-10">
                            {table.getHeaderGroups().map(headerGroup => (
                                <tr key={headerGroup.id}>
                                    {headerGroup.headers.map(header => (
                                        <th
                                            key={header.id}
                                            className="p-2 text-sm border-b bg-gray-300 whitespace-nowrap"
                                        >
                                            {flexRender(
                                                header.column.columnDef.header,
                                                header.getContext()
                                            )}
                                        </th>
                                    ))}
                                </tr>
                            ))}
                        </thead>
                        <tbody>
                            {table.getRowModel().rows.map(row => (
                                <tr key={row.id} className="hover:bg-gray-50">
                                    {row.getVisibleCells().map(cell => (
                                        <td
                                            key={cell.id}
                                            className="p-2 border-b  text-sm whitespace-nowrap"
                                        >
                                            {flexRender(
                                                cell.column.columnDef.cell,
                                                cell.getContext()
                                            )}
                                        </td>
                                    ))}
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default Moresubstable;

